import React, { useState, useMemo, useEffect } from 'react';
import { TextField } from '@mui/material';
import { Autocomplete } from '@mui/material';

function CompteSearch(props) {
    const [searchTerm, setSearchTerm] = useState('');
    const [selected, setSelect] = useState('')
    const [open, setOpen] = useState(false)

    const filteredComptes = useMemo(() => {
        if (searchTerm.length < 2) return [];
        
        const lowerSearchTerm = searchTerm.toLowerCase();
        return props.comptes.filter(cpt => 
        cpt.libelle.toLowerCase().startsWith(lowerSearchTerm) ||
        cpt.num_compte.toLowerCase().startsWith(lowerSearchTerm)
        );
    }, [searchTerm, props.comptes]);

    const handleSelect = (event, value) => {
        if (value) {
        props.setCompte(value)
        setSelect(value._id)
        }
    };

    useEffect(()=>{
        if (Boolean(props.default)) {
            setSelect(props.default); setOpen(false)
        }
        
    }, [props.default])

    return (
        <Autocomplete
        sx={props.style}
        options={filteredComptes}
        getOptionLabel={(option) => option!==''? `${option.num_compte} - ${option.libelle}`:''}
        renderInput={(params) => <TextField {...params} label="Rechercher un compte" />}
        value={selected}
        onInputChange={(event, newInputValue) => {
            setSearchTerm(newInputValue);
            setOpen(newInputValue.length>1)
        }}
        onChange={handleSelect}
        filterOptions={(x) => x} // Désactive le filtrage interne d'Autocomplete
        noOptionsText={searchTerm.length>1&&"Aucun compte trouvé"}
        open={open}
        onOpen={()=>setOpen(searchTerm.length>1)}
        onClose={()=>setOpen(false)}
        />
    );
}

export default CompteSearch;